import { appConfig, headerConfig, refineHeader } from "../../config";

export const faqService = {
  add_faq,
  get_faq_list,
  delete_faq,
  get_faq_details,
  update_faq,
  get_faq_frontend,
  add_vote,
  get_faq_check_vote,
};

function add_faq(postData) {
  refineHeader();
  const requestOptions = {
    method: "POST",
    headers: headerConfig.headerDatas,
    mode: "cors",
    IDBTransaction,
    body: JSON.stringify(postData),
  };

  return fetch(`${appConfig.api.url}faq/add`, requestOptions)
    .then(handleResponse)
    .then((data) => {
      return data;
    });
}

function add_vote(postData) {
  refineHeader();
  const requestOptions = {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      secretkey: appConfig.site.secret_key,
      "Access-Control-Allow-Origin": "*",
    },
    mode: "cors",
    IDBTransaction,
    body: JSON.stringify(postData),
  };

  return fetch(`${appConfig.api.url}faq/vote`, requestOptions)
    .then(handleResponse)
    .then((data) => {
      return data;
    });
}

function get_faq_list(postData) {
  refineHeader();
  const requestOptions = {
    method: "POST",
    headers: headerConfig.headerDatas,
    mode: "cors",
    IDBTransaction,
    body: JSON.stringify(postData),
  };

  return fetch(`${appConfig.api.url}faq/list`, requestOptions)
    .then(handleResponse)
    .then((data) => {
      return data;
    });
}

function get_faq_details(quesID) {
  refineHeader();
  const requestOptions = {
    method: "POST",
    headers: headerConfig.headerDatas,
    mode: "cors",
  };

  return fetch(`${appConfig.api.url}faq/detail/${quesID}`, requestOptions)
    .then(handleResponse)
    .then((data) => {
      return data;
    });
}

function delete_faq(quesID) {
  refineHeader();
  const requestOptions = {
    method: "DELETE",
    headers: headerConfig.headerDatas,
    mode: "cors",
    // body: JSON.stringify()
  };

  return fetch(`${appConfig.api.url}faq/delete/${quesID}`, requestOptions)
    .then(handleResponse)
    .then((data) => {
      return data;
    });
}

function update_faq(postData) {
  refineHeader();
  const requestOptions = {
    method: "PUT",
    headers: headerConfig.headerDatas,
    mode: "cors",
    IDBTransaction,
    body: JSON.stringify(postData),
  };

  return fetch(`${appConfig.api.url}faq/edit`, requestOptions)
    .then(handleResponse)
    .then((data) => {
      return data;
    });
}

function get_faq_frontend(postData) {
  const requestOptions = {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      secretkey: appConfig.site.secret_key,
      "Access-Control-Allow-Origin": "*",
    },
    mode: "cors",
    IDBTransaction,
    body: JSON.stringify(postData),
  };

  return fetch(`${appConfig.api.url}faq/front-faq-list`, requestOptions)
    .then(handleResponse)
    .then((data) => {
      return data;
    });
}

function get_faq_check_vote(postData) {
  const requestOptions = {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      secretkey: appConfig.site.secret_key,
      "Access-Control-Allow-Origin": "*",
    },
    mode: "cors",
    IDBTransaction,
    body: JSON.stringify(postData),
  };

  return fetch(`${appConfig.api.url}faq/check-vote`, requestOptions)
    .then(handleResponse)
    .then((data) => {
      return data;
    });
}

function handleResponse(response) {
  return response.text().then((text) => {
    const data = text && JSON.parse(text);
    if (!response.ok) {
      if (response.status === 401) {
      }

      const error = (data && data.message) || response.statusText;
      return Promise.reject(error);
    }

    return data;
  });
}



// WEBPACK FOOTER //
// ./src/app/services/API/faqService.js